import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({ selector: '[appPreventPaste]' })
export class PreventPasteDirective {
  private lastValue = '';

  constructor(private el: ElementRef<HTMLInputElement>) {}

  @HostListener('paste', ['$event'])
  onPaste(e: ClipboardEvent) { e.preventDefault(); }

  @HostListener('drop', ['$event'])
  onDrop(e: DragEvent) { e.preventDefault(); }

  // Catch more than paste/drop (including replacement-style inserts)
  @HostListener('beforeinput', ['$event'])
  onBeforeInput(e: InputEvent) {
    const t = e.inputType;

    // Blocks: paste, drop, and many autofill / password-manager “replace” behaviors
    if (
      t === 'insertFromPaste' ||
      t === 'insertFromDrop' ||
      t === 'insertReplacementText'
    ) {
      e.preventDefault();
      this.clear();
    }
  }

  @HostListener('input')
  onInput() {
    const el = this.el.nativeElement;
    const v = el.value ?? '';

    // digits only
    if (!/^\d*$/.test(v)) return this.clear();

    // optional: detect sudden multi-char insertion
    if (Math.abs(el.value.length - this.lastValue.length) > 1) {
      return this.clear();
    }

    this.lastValue = el.value;
  }

  private clear() {
    const el = this.el.nativeElement;
    el.value = '';
    this.lastValue = '';
    // if you rely on ngModel, also dispatch an input event so Angular updates
    el.dispatchEvent(new Event('input', { bubbles: true }));
  }
}
